import { ComponentProps } from 'react';
import lighten from 'polished/lib/color/lighten';
import { Charts } from '@perch-labs/shrike';
// used to lighten a color associated with a index of a data array
const lightenIndexMultiplier = 0.08;
export const buildDonutData = ({
  activeEnergySource,
  donutBreakdown,
  energySourceLabelMap,
  theme,
}) =>
  Object.keys(donutBreakdown).map((key, index) => {
    const seriesObj = {} as NonNullable<
      ComponentProps<typeof Charts.Donut>['series']
    >[number];
    if (key === activeEnergySource) seriesObj.color = theme.colors.alternative1;
    else
      seriesObj.color = lighten(
        index * lightenIndexMultiplier,
        theme.colors.alternative3
      );
    seriesObj.value = Math.round(donutBreakdown[key] * 100);
    seriesObj.label = energySourceLabelMap[key];
    return seriesObj;
  });
